<div class="nav-bar">
  <div class="nav-bar-left">
    <img src="../../../assets/Lytx_logo_RGB.png"
         alt="Lytx">
    <span class="nav-bar-title">Device Control Center</span>
  </div>
  <div class="nav-bar-center">
    <a *ngFor="let link of links"
       [routerLink]="link.path"
       routerLinkActive="active"
       [ngClass]="{'hidden': link.hidden, 'disabled': link.disabled}"
       class="nav-bar-link">{{link.name}}</a>
  </div>
  <div class="nav-bar-right">
    <a *ngIf="showAiNoc"
       routerLink="/ai-noc"
       routerLinkActive="active"
       class="nav-bar-ai-noc-btn"><span class="nav-bar-ai-noc-btn-icon">✦</span>AI NOC</a>
    <a class="nav-bar-link" (click)="logOut()">Sign Out</a>
  </div>
</div>
